import BaseModel from '../BaseModel';

export default class Template extends BaseModel {
  static entity = 'templates';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      default: this.boolean(false),
      templateData: this.attr(null),
      pictureUrl: this.attr(null),
      templateHasChanges: this.boolean(false),
      companyId: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetch() {
        this.get('companies/templates');
      },
    },
  }
}
